import React from 'react'
import HeroServiziPage from '../Components/Hero/HeroServiziPage';
import Servizi from '../Components/Servizi/ServiziPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: "Servizi Estetica",
    description: "<h4>Salute intima e ginecologica in ogni fase della vita, dalla pubert&agrave; alla menopausa.</h4>"
        + "Visite, ecografie, prevenzione, fertilit&agrave; e trattamenti mirati per il benessere ormonale. Approccio personalizzato e tecniche non invasive per migliorare la qualit&agrave della vita femminile."
};

const ServiziData = {
    img:"/images/cardiology.png",
    content2: `
        <h2>Rimozione Tatuaggi: Un Nuovo inizio per la tua pelle</h2>
        <p>A volte, i tatuaggi che abbiamo scelto in un momento della nostra vita non riflettono pi&ugrave; chi siamo oggi. Puoi finalmente dire addio a quei tatuaggi indesiderati, con una tecnologia avanzata che rispetta la tua pelle e ti offre risultati visibili e duraturi.</p>

        <h3>Come Funziona?</h3>
        <ul>
          <li><strong>Laser Q-Switched:</strong> Utilizzando impulsi laser brevissimi, il nostro laser frammenta il pigmento del tatuaggio in piccole particelle.</li>
          <li><strong>Guarigione Naturale:</strong> Il corpo poi elimina queste particelle in modo naturale attraverso il normale processo di guarigione della pelle.</li>
          <li><strong>Tecnologia ClearLift:</strong> Questa tecnologia penetra in profondit&agrave; senza danneggiare la pelle superficiale, garantendo trattamenti sicuri ed efficaci senza rischio di cicatrici.</li>
        </ul>

        <h3>I Benefici per Te</h3>
        <ul>
          <li><strong>Recupero Rapido:</strong> Il trattamento &egrave; veloce e non richiede tempi di recupero lunghi, cos&igrave; puoi tornare alle tue attivit&agrave; quotidiane senza interruzioni.</li>
          <li><strong>Sicurezza Totale:</strong> Grazie alla tecnologia avanzata, il trattamento non danneggia la pelle e non lascia cicatrici, solo risultati puliti e senza segni.</li>
          <li><strong>Risultati Duraturi:</strong> Dopo poche sedute, il tatuaggio scomparir&agrave;, lasciandoti con una pelle libera e pronta per il nuovo capitolo della tua vita.</li>
        </ul>
        <br><br><br><br>
    `,
    content1: `
        <h2>Epiliazione Laser Medicale</h2>
        <p>L&apos;epilazione laser medicale con tecnologia Alma Laser &egrave; la soluzione pi&ugrave; efficace presente sul mercato, grazie alla sua potenza e alla combinazione di tre lunghezze d&apos;onda. Questo sistema avanzato permette di trattare tutti i tipi di pelle, anche abbronzata, e di agire in profondit&agrave; sul follicolo pilifero per risultati rapidi, duraturi e sicuri.</p>

        <h3>Perch&eacute; scegliere questo trattamento?</h3>
        <ul>
          <li>La tecnologia pi&ugrave; potente ed efficace disponibile</li>
          <li>Tre lunghezze d&apos;onda per un&apos;azione completa e mirata</li>
          <li>Trattamento veloce ed efficace su tutte le aree del corpo</li>
          <li>Sistema di raffreddamento integrato per il massimo comfort</li>
          <li>Adatto a ogni fototipo, inclusa la pelle abbronzata</li>
          <li>Riduzione progressiva e permanente dei peli superflui</li>
        </ul>

        <h3>Come funziona?</h3>
        <p>Il trattamento sfrutta l&apos;azione combinata di tre lunghezze d&apos;onda per un&apos;epilazione completa e sicura:</p>
        <ul>
          <li><strong>ALEX 755 nm:</strong> efficace anche su peli chiari e sottili</li>
          <li><strong>SPEED 810 nm:</strong> ideale per tutti i tipi di pelle, raggiunge direttamente il bulbo pilifero</li>
          <li><strong>YAG 1064 nm:</strong> perfetto per peli pi&ugrave; scuri e per un&apos;azione in profondit&agrave;</li>
        </ul>
        <p>Grazie alla tecnologia pi&ugrave; avanzata disponibile, questo trattamento offre un&apos;epilazione sicura, indolore ed estremamente efficace. Scegli una soluzione definitiva per una pelle liscia e senza peli indesiderati.</p>
        <br>
    `,
};

const AboutPage = () => {
  return (
    <>
      <HeroServiziPage data={heroData} />
      <Servizi data={ServiziData} />
    </>
  )
}

export default AboutPage
